// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Report$ReactHooksTemplate = require("../reports/report.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var EmailContent$ReactHooksTemplate = require("./emailContent.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../common/MultipleSelectBox.res.js");

function EmailContentItem(props) {
  var reports = props.reports;
  var dataFields = props.dataFields;
  var updateEmailContentAt = props.updateEmailContentAt;
  var index = props.index;
  var emailContent = props.emailContent;
  var deleteEmailContentAt = props.deleteEmailContentAt;
  var match = EmailContent$ReactHooksTemplate.id(emailContent);
  var isPresent = match !== undefined;
  var match$1 = React.useState(function (param) {
        return isPresent;
      });
  var setCollapsed = match$1[1];
  var collapsed = match$1[0];
  var inputBase = "w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition duration-150";
  var labelBase = "block text-sm font-medium text-gray-700 mb-1.5";
  var tmp;
  if (collapsed) {
    tmp = null;
  } else {
    var reportOptions = List.map(Report$ReactHooksTemplate.name, reports);
    var __x = EmailContent$ReactHooksTemplate.reportIds(emailContent);
    var selectedReportNames = Belt_List.flatten(Belt_List.map(__x, (function (id) {
                var r = Belt_List.getBy(reports, (function (r) {
                        return Caml_obj.equal(Report$ReactHooksTemplate.id(r), id);
                      }));
                if (r !== undefined) {
                  return {
                          hd: Report$ReactHooksTemplate.name(r),
                          tl: /* [] */0
                        };
                } else {
                  return /* [] */0;
                }
              })));
    var handleReportToggle = function (reportName) {
      var __x = Belt_List.getBy(reports, (function (r) {
              return Report$ReactHooksTemplate.name(r) === reportName;
            }));
      var reportId = Belt_Option.flatMap(__x, Report$ReactHooksTemplate.id);
      if (reportId === undefined) {
        return ;
      }
      var currentIds = EmailContent$ReactHooksTemplate.reportIds(emailContent);
      var updatedIds = List.exists((function (x) {
              return x === reportId;
            }), currentIds) ? List.filter(function (x) {
                return x !== reportId;
              })(currentIds) : List.append(currentIds, {
              hd: reportId,
              tl: /* [] */0
            });
      Curry._2(updateEmailContentAt, index, (function (ec) {
              return EmailContent$ReactHooksTemplate.setReportIds(ec, updatedIds);
            }));
    };
    var tf = EmailContent$ReactHooksTemplate.timeFrame(emailContent);
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("section", {
                  children: [
                    JsxRuntime.jsx("label", {
                          children: "Name",
                          className: labelBase,
                          htmlFor: "email-content-name-" + String(index)
                        }),
                    JsxRuntime.jsx("input", {
                          className: inputBase,
                          id: "email-content-name-" + String(index),
                          placeholder: "e.g. Ticket notification",
                          type: "text",
                          value: EmailContent$ReactHooksTemplate.name(emailContent),
                          onChange: (function ($$event) {
                              var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                              Curry._2(updateEmailContentAt, index, (function (ec) {
                                      return EmailContent$ReactHooksTemplate.setName(ec, value);
                                    }));
                            })
                        })
                  ],
                  className: "space-y-2"
                }),
            JsxRuntime.jsxs("section", {
                  children: [
                    JsxRuntime.jsx("label", {
                          children: "Subject",
                          className: labelBase,
                          htmlFor: "email-content-subject-" + String(index)
                        }),
                    JsxRuntime.jsx("input", {
                          className: inputBase,
                          id: "email-content-subject-" + String(index),
                          placeholder: "e.g. New ticket created",
                          type: "text",
                          value: EmailContent$ReactHooksTemplate.subject(emailContent),
                          onChange: (function ($$event) {
                              var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                              Curry._2(updateEmailContentAt, index, (function (ec) {
                                      return EmailContent$ReactHooksTemplate.setSubject(ec, value);
                                    }));
                            })
                        })
                  ],
                  className: "space-y-2"
                }),
            JsxRuntime.jsxs("section", {
                  children: [
                    JsxRuntime.jsx("label", {
                          children: "Body",
                          className: labelBase,
                          htmlFor: "email-content-body-" + String(index)
                        }),
                    JsxRuntime.jsx("textarea", {
                          className: inputBase + " min-h-[120px] resize-y",
                          id: "email-content-body-" + String(index),
                          placeholder: "Enter email body. You can use dynamic content placeholders from the list below.",
                          rows: 5,
                          value: EmailContent$ReactHooksTemplate.body(emailContent),
                          onChange: (function ($$event) {
                              var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                              Curry._2(updateEmailContentAt, index, (function (ec) {
                                      return EmailContent$ReactHooksTemplate.setBody(ec, value);
                                    }));
                            })
                        })
                  ],
                  className: "space-y-2"
                }),
            JsxRuntime.jsxs("section", {
                  children: [
                    JsxRuntime.jsx("h4", {
                          children: "Report (optional)",
                          className: "text-sm font-semibold text-gray-800 mb-1"
                        }),
                    JsxRuntime.jsx("p", {
                          children: "Attach one or more reports to this email. Select reports and date range.",
                          className: "text-sm text-gray-600 mb-4"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("label", {
                                          children: "Reports",
                                          className: labelBase,
                                          htmlFor: "email-content-report-" + String(index)
                                        }),
                                    JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                          options: reportOptions,
                                          placeholder: "Select reports...",
                                          handleChange: handleReportToggle,
                                          selectedOptions: selectedReportNames,
                                          className: "w-full min-h-[44px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
                                        })
                                  ]
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("label", {
                                          children: "Date range",
                                          className: labelBase,
                                          htmlFor: "email-content-time-frame-" + String(index)
                                        }),
                                    JsxRuntime.jsxs("select", {
                                          children: [
                                            JsxRuntime.jsx("option", {
                                                  children: "— None —",
                                                  value: ""
                                                }),
                                            $$Array.of_list(List.map((function (tf) {
                                                        return JsxRuntime.jsx("option", {
                                                                    children: Utils$ReactHooksTemplate.humanize(tf),
                                                                    value: tf
                                                                  }, tf);
                                                      }), props.timeFrames))
                                          ],
                                          className: inputBase + " bg-white",
                                          id: "email-content-time-frame-" + String(index),
                                          value: tf !== undefined ? tf : "",
                                          onChange: (function ($$event) {
                                              var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                              var timeFrame = value === "" ? undefined : Caml_option.some(value);
                                              Curry._2(updateEmailContentAt, index, (function (ec) {
                                                      return EmailContent$ReactHooksTemplate.setTimeFrame(ec, timeFrame);
                                                    }));
                                            })
                                        })
                                  ]
                                })
                          ],
                          className: "grid grid-cols-1 sm:grid-cols-2 gap-5"
                        })
                  ],
                  className: "mt-6 rounded-xl border border-indigo-100 bg-indigo-50/30 p-5 shadow-sm"
                }),
            JsxRuntime.jsxs("section", {
                  children: [
                    JsxRuntime.jsx("h4", {
                          children: "Survey responses in email",
                          className: "text-sm font-semibold text-gray-800 mb-1"
                        }),
                    JsxRuntime.jsx("p", {
                          children: "When enabled, the ticket alert email includes all survey responses from that ticket's transaction.",
                          className: "text-sm text-gray-600 mb-4"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                  checked: EmailContent$ReactHooksTemplate.includeSurveyResponses(emailContent),
                                  handleChange: (function (param) {
                                      Curry._2(updateEmailContentAt, index, (function (ec) {
                                              return EmailContent$ReactHooksTemplate.setIncludeSurveyResponses(ec, !EmailContent$ReactHooksTemplate.includeSurveyResponses(ec));
                                            }));
                                    }),
                                  labelClassName: "flex items-center"
                                }),
                            JsxRuntime.jsx("span", {
                                  children: "Include survey responses from ticket",
                                  className: "text-sm font-medium text-gray-700"
                                }),
                            EmailContent$ReactHooksTemplate.includeSurveyResponses(emailContent) ? JsxRuntime.jsx("span", {
                                    children: "Enabled",
                                    className: "inline-flex items-center px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full"
                                  }) : JsxRuntime.jsx("span", {
                                    children: "Disabled",
                                    className: "inline-flex items-center px-2 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-full"
                                  })
                          ],
                          className: "flex items-center space-x-3"
                        })
                  ],
                  className: "mt-6 rounded-xl border border-emerald-100 bg-emerald-50/30 p-5 shadow-sm"
                }),
            JsxRuntime.jsxs("section", {
                  children: [
                    JsxRuntime.jsxs("label", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: "Data field placeholders",
                                  className: "text-xs font-semibold text-gray-600 uppercase tracking-wide"
                                }),
                            JsxRuntime.jsx("span", {
                                  children: "Add fields to use as placeholders in subject or body.",
                                  className: "block text-sm text-gray-500 mt-0.5"
                                })
                          ],
                          className: "block mb-3"
                        }),
                    JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                          options: List.map(DataField$ReactHooksTemplate.name, dataFields),
                          placeholder: "Add data field...",
                          handleChange: (function (dataField) {
                              Curry._2(updateEmailContentAt, index, (function (ec) {
                                      var xs = EmailContent$ReactHooksTemplate.dataFields(ec);
                                      var currentFields = xs !== undefined ? xs : /* [] */0;
                                      var updatedFields = List.exists((function (df) {
                                              return DataField$ReactHooksTemplate.name(df) === dataField;
                                            }), currentFields) ? List.filter(function (df) {
                                                return DataField$ReactHooksTemplate.name(df) !== dataField;
                                              })(currentFields) : List.append(currentFields, List.filter(function (df) {
                                                    return DataField$ReactHooksTemplate.name(df) === dataField;
                                                  })(dataFields));
                                      return EmailContent$ReactHooksTemplate.setDataFields(ec, updatedFields);
                                    }));
                            }),
                          selectedOptions: props.selectedDataFieldNames,
                          className: "w-full min-h-[44px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
                        })
                  ],
                  className: "mt-6 relative rounded-lg border border-gray-200 bg-gray-50/50 p-4"
                })
          ],
          className: "p-6 space-y-6 bg-white"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: EmailContent$ReactHooksTemplate.name(emailContent),
                              className: "text-sm font-semibold text-gray-800"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: collapsed ? JsxRuntime.jsx("img", {
                                              className: "w-4 h-4",
                                              alt: "Expand",
                                              src: Image$ReactHooksTemplate.doubleMinimize
                                            }) : JsxRuntime.jsx("img", {
                                              className: "w-4 h-4",
                                              alt: "Minimize",
                                              src: Image$ReactHooksTemplate.minimize
                                            }),
                                      className: "p-2 rounded-lg hover:bg-gray-200 transition-colors duration-200",
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(setCollapsed, (function (c) {
                                                  return !c;
                                                }));
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "w-4 h-4",
                                            alt: "Delete",
                                            src: Image$ReactHooksTemplate.trashGrey
                                          }),
                                      className: "p-2 rounded-lg hover:bg-red-100 transition-colors duration-200",
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(deleteEmailContentAt, index);
                                        })
                                    })
                              ],
                              className: "flex items-center gap-2"
                            })
                      ],
                      className: "flex items-center justify-between px-5 py-4 bg-gradient-to-r from-gray-50 to-blue-50 border-b border-gray-200"
                    }),
                tmp
              ],
              className: "bg-white my-4 border border-gray-200 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            });
}

var make = EmailContentItem;

exports.make = make;
/* react Not a pure module */
